import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./Modal.module.scss";
import { combineClasses } from "utils/utils";
import CrossIconSVG from "components/SVGComponents/CrossIconSVG";
import { useBlockScroll } from "hooks";

const withModalOpen = (WrappedComponent) => {
  return function ConditionalModal(props) {
    const { modalOpen } = props;
    if (!modalOpen) return null;
    return <WrappedComponent {...props} />;
  };
};

const Modal = ({
  modalOpen,
  onClose,
  heading,
  shadowClassName = "",
  wrapperClassName = "",
  bodyClassName = "",
  headerClassName = "",
  children,
  doNotClose = false,
  height = "auto",
  width = "45rem",
  background = "#fafbff",
  showCrossIcon = false,
  shouldBlock = true,
  drawer = {
    isDrawer: false,
    position: "bottom",
    mobileOnly: false,
    heading: "",
    isCloseIcon: false,
    CloseIcon: null,
  },
}) => {
  const { isDrawer, drawerHeaderClassName } = drawer;

  // Lock scroll when modal is open

  useBlockScroll(modalOpen && shouldBlock);

  if (!modalOpen) return null;
  return ReactDOM.createPortal(
    <div
      className={combineClasses(styles.mainContainer, shadowClassName)}
      onMouseDown={(e) => {
        e.stopPropagation();
        !doNotClose && onClose(false);
      }}
    >
      <div
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          height: height,
          backgroundColor: background || "#fafbff",
          width: width,
        }}
        className={combineClasses(
          styles.modalDiv,
          isDrawer ? styles.drawerDiv : "",
          wrapperClassName
        )}
      >
        {heading && typeof heading === "string" ? (
          <div className={combineClasses(styles.modalHeader, headerClassName)}>
            <p>{heading}</p>
            {showCrossIcon && (
              <button onClick={onClose}>
                <CrossIconSVG />
              </button>
            )}
          </div>
        ) : (
          heading
        )}

        {drawer?.heading && typeof drawer?.heading === "string" ? (
          <div
            className={combineClasses(
              styles.drawerHeading,
              drawerHeaderClassName
            )}
            onClick={onClose}
          >
            {drawer.isCloseIcon && (
              <div className={styles.drawerCloseIcon}>
                {drawer.CloseIcon ? (
                  drawer.CloseIcon
                ) : (
                  <CrossIconSVG color="black" height="24" width="24" />
                )}
              </div>
            )}
            <p>{drawer?.heading}</p>
          </div>
        ) : (
          drawer?.heading
        )}
        <div className={combineClasses(styles.modalBody, bodyClassName)}>
          {children}
        </div>
      </div>
    </div>,
    document.getElementById("root")
  );
};

export default withModalOpen(Modal);
